import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
